import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { signupWithLambda } from '../repository/authRepository';
import { setupAutoRefresh } from '../utils/tokenRefresh';

export const Signup: React.FC = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password1, setPassword1] = useState('');
  const [password2, setPassword2] = useState('');
  const [tosAccepted, setTosAccepted] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    const response = await signupWithLambda({
      username, email, password1, password2,
      terms_of_service: tosAccepted,
    });

    if ('error' in response) {
      setError(response.error || 'An error occurred');
    } else if (response.access && response.refresh && response.user) {
      localStorage.setItem('access_token', response.access);
      localStorage.setItem('refresh_token', response.refresh);
      localStorage.setItem('user', JSON.stringify(response.user));
      setupAutoRefresh();
      navigate('/');
    } else {
      navigate('/login');
    }

    setIsLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="card auth-card">
        <h2 className="auth-title">Sign up</h2>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="username">Username</label>
            <input id="username" type="text" className="form-input" value={username}
              onChange={e => setUsername(e.target.value)} required disabled={isLoading} maxLength={30} />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="email">Email</label>
            <input id="email" type="email" className="form-input" value={email}
              onChange={e => setEmail(e.target.value)} required disabled={isLoading} />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password1">Password</label>
            <input id="password1" type="password" className="form-input" value={password1}
              onChange={e => setPassword1(e.target.value)} required disabled={isLoading} minLength={8} />
          </div>

          <div className="form-group">
            <label className="form-label" htmlFor="password2">Confirm password</label>
            <input id="password2" type="password" className="form-input" value={password2}
              onChange={e => setPassword2(e.target.value)} required disabled={isLoading} />
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input type="checkbox" checked={tosAccepted} onChange={e => setTosAccepted(e.target.checked)}
                required disabled={isLoading} />
              I agree to the Terms of Service
            </label>
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={isLoading}>
            {isLoading ? 'Creating account...' : 'Sign Up'}
          </button>
        </form>

        <div className="auth-footer">
          Already have an account? <Link to="/login">Log in</Link>
        </div>
      </div>
    </div>
  );
};
